import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ParamterType, SupplementaryEquipment } from '@sdbn/appclient';
import { SupplementaryEquipmentSelectionItem } from '../../register-entrance-leave.model';

@Component({
  selector: 'app-supplementary-equipment-item',
  templateUrl: './supplementary-equipment-item.component.html',
  styleUrls: ['./supplementary-equipment-item.component.scss']
})
export class SupplementaryEquipmentItemComponent implements OnInit {

  ParamterType = ParamterType;

  @Input() supplementaryEquipment: SupplementaryEquipment;

  @Output() changed = new EventEmitter<SupplementaryEquipmentSelectionItem>();

  selected = false;

  formGroup = new FormGroup({
    checked: new FormControl(false, []),
    parameter1: new FormControl(null, [])
  });

  constructor() { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.selected = value.checked;
      this.changed.next(new SupplementaryEquipmentSelectionItem({
        key: this.supplementaryEquipment.key,
        checked: value.checked,
        parameter1: value.parameter1
      }));
    });

  }

}
